import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomItemVerticalFourComponent } from './custom-item-vertical-four.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [CustomItemVerticalFourComponent],
  exports: [CustomItemVerticalFourComponent],
    imports: [
        CommonModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ItemVerticalFourComponent: {
                    component: CustomItemVerticalFourComponent,
                },
            },
        } as CmsConfig),
        RouterModule,
    ]
})
export class CustomItemVerticalFourModule { }
